import CloseIcon from "../../assets/icons/close-icon-black.svg";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
interface DeleteDialogProps {
  open: boolean;
  rows?: any;
  campaignNames?: any;
  type?: "campaign" | "segment";
  name?: string;
  onClose: () => void;
  onDelete?: () => void;
}

const DialogDeleteComponent = ({ open, onClose, onDelete, type, campaignNames, name }: DeleteDialogProps) => {

  const handleDeleteClick = () => {
    if (onDelete) onDelete();
    onClose();
  };
  let content;

  switch (type) {
    case "campaign":
      content = {
        title: "Delete campaign",
        subTitle: "You are about to delete the campaign ",
        subTitleStrong: "Please confirm that you want to continue.",
      };
      break;
    case "segment":
      content = {
        title: "Delete segment",
        subTitle: "You are about to delete the segment ",
        subTitleStrong: "Please confirm that you want to continue.",
      };
      break;

    default:
      break;
  }

  const { title, subTitle, subTitleStrong } = content || {};

  return (
    <Dialog open={open} onClose={onClose} className="general-dialog">
      <DialogTitle className="custom-dialog-title">
        <div className="view-all-attributes__title">{title}</div>
        <img className="close-icon" src={CloseIcon} alt="close icon" onClick={onClose} />
      </DialogTitle>
      <DialogContent className="dialog-download">
        <div className="dataset-sec">
          <div className="view-all-attributes__dataset-wrapper__label">
            {subTitle} {name}
            <br />
            <strong>{subTitleStrong}</strong>
          </div>
        </div>
       {type === "segment" && campaignNames?.length> 0 && campaignNames[0] !== "-" && (
          <div className="mt-3">
            <p>This segment is currently used in:</p>
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {campaignNames.map((row: any) => (
                    <TableRow key={row} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        {row}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <button type="button" className="btn-border" onClick={onClose}>
          Cancel
        </button>
        <button type="button" className="btn-primary" onClick={handleDeleteClick}>
          Delete
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogDeleteComponent;
